import React from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { getHeaderTooltip } from "../tooltips"; 
import { ReactComponent as FootbalIcon } from "../../../../../assets/utils/images/svgs/football-planscreen.svg";
import "../../../../../assets/pages/_planscreen.scss";


export default function ColumnHeader({ name, value, isLock, ...otherProps }) {
  const headerName = name === "Gym" ? <FootbalIcon /> : name;
  const tip = getHeaderTooltip(name, value);

  const base =
    "d-flex justify-content-center align-items-center border rounded planscreen__column-header";

  const btnProps = {
    className: base,
    disabled: isLock,
    "data-col-name": name,
    "data-col-value": value,
    ...otherProps,
  };

  let button;
  switch (value) {
    case "N":
      button = (
        <button {...btnProps} className={`${base} planscreen__column-header--disabled`}>
          {headerName}
        </button>
      );
      break;
    case "-":
      button = (
        <button {...btnProps} className={`${base} planscreen__column-header--minus`}>
          {headerName}
        </button>
      );
      break;
    case "+!":
      button = (
        <button {...btnProps} className={`${base} planscreen__column-header--success-unknown`}>
          {typeof headerName === "string"
            ? headerName.split("").map((ch, i) => (
                <div
                  className={i % 2 ? "planscreen__column-header--unknown" : "planscreen__column-header--success"}
                  key={i}
                >
                  {ch}
                </div>
              ))
            : headerName}
        </button>
      );
      break;
    case "!":
      button = (
        <button {...btnProps} className={`${base} planscreen__column-header--unknown`}>
          {headerName}
        </button>
      );
      break;
    default:
      button = <button {...btnProps}>{headerName}</button>;
  }


  return tip ? (
    <Tippy content={tip} placement="top" arrow>
      <span>{button}</span>
    </Tippy>
  ) : (
    button
  );
}
